import { AppRoutes } from '~/constants/routes'
import { OrganizationRoles } from '~/constants/organizations'

export default defineNuxtRouteMiddleware(async () => {
  if (!isUserGrantedInOrganization(OrganizationRoles.Owner)) {
    return navigateTo(AppRoutes.SelectOrganization)
  }
})
